
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CrewPermissionsService } from './crew-permissions.service';

@Component({
    selector: "crew-edit-buttons",
    template: require('./edit-buttons.component.html')
})
export class EditButtons {

    isPermissionWriteOrAdmin: boolean;

    constructor(crewPermissionsService: CrewPermissionsService) {
        // default values
        this.editText = "Edit";
        this.deleteText = "Delete";
        this.backToListText = "Back to list"
        this.isBackToListVisible = true;

        crewPermissionsService.isPermissionWriteOrAdmin().subscribe(value => this.isPermissionWriteOrAdmin = value);
    }

    @Input()
    editText: string;

    @Input()
    deleteText: string;

    @Input()
    isBackToListVisible: boolean;

    @Input()
    backToListText: string;

    @Output()
    onEdit = new EventEmitter();

    @Output()
    onDelete = new EventEmitter();

    @Output()
    onBackToList = new EventEmitter();

    edit() {
        this.onEdit.emit();
    }

    delete() {
        this.onDelete.emit();
    }

    backToList() {
        this.onBackToList.emit();
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/edit-buttons.component.ts